export class RootController implements ng.IController {
    static $inject = [ "$mdDialog", "$window"];
        constructor( private $mdDialog: angular.material.IDialogService, private $window: ng.IWindowService) {
        
    }

    $onInit() { }
}

angular
    .module("deliveryCreate.app")
    .controller("RootController", RootController);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/root/RootController.ts
 **/